/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum MetadataType {
    ACTION_DETAILS,
    ACTION_LIST,
    AIRING,
    DELETE_RECORDING,
    FULL_INFO_PREVIEW,
    NDVR_LAST_VIEWED_POSITION,
    PREVIEW,
    RECORDING_ACTION_LIST,
    VOD_ACTION_LIST,
}
